"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableModuleFragment = void 0;
var _fetching = require("@ori/fetching");
const tableModuleFragment = exports.tableModuleFragment = (0, _fetching.gql)`
  fragment TableModule on TableModule {
    __typename
    editorialContentType
    id
    title
    description
    columnDefinitions {
      key
      label
    }
    rows {
      cells {
        value {
          text
          textLinks {
            id
            title
            relativeUrl
          }
        }
        columnKey
      }
    }
  }
`;
